// src/components/BenvenutoNuovoUtente.js
// Riga viola sotto «Ciao …» in Home, per chi è appena arrivato (prime 2 settimane dal primo
// ingresso; prima erano 30 giorni): dice in una frase dove trovare le cose — Home, menu,
// ricerca, Guida — con i collegamenti già pronti e «Apri la guida →». Testo viola su fondo
// chiaro con bordo viola (prima era a fondo viola pieno). Si chiude
// con la ✕ e non ricompare (users.nascondiBenvenuto). Chi usa Nexiora da tempo non la vede.
// Ottobre 2026: ha preso il posto di «Le sezioni pensate per te», che si mostravano sempre.
import React, { useEffect, useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../contexts/AuthContext";
import { X } from "lucide-react";
import { STILE_AVVISO_VIOLA } from "./AvvisoViola";

const GIORNI_BENVENUTO = 14;

function useTelefono() {
  const leggi = () => typeof window !== "undefined" && window.innerWidth < 768;
  const [t, setT] = useState(leggi);
  useEffect(() => { const su = () => setT(leggi()); window.addEventListener("resize", su); return () => window.removeEventListener("resize", su); }, []);
  return t;
}

export default function BenvenutoNuovoUtente() {
  const { currentUser, userProfile, isPlatformOwner } = useAuth();
  const telefono = useTelefono();
  const [chiuso, setChiuso] = useState(!!userProfile?.nascondiBenvenuto);
  useEffect(() => setChiuso(!!userProfile?.nascondiBenvenuto), [userProfile?.nascondiBenvenuto]);

  const primoIngresso = userProfile?.createdAt?.toDate ? userProfile.createdAt.toDate() : null;
  const nuovo = !isPlatformOwner && !!primoIngresso && (Date.now() - primoIngresso.getTime()) < GIORNI_BENVENUTO * 86400000;
  if (!nuovo || chiuso) return null;

  const chiudi = async () => {
    setChiuso(true);
    try { await updateDoc(doc(db, "users", currentUser.uid), { nascondiBenvenuto: true }); } catch { /* resta chiusa in questa sessione */ }
  };
  const apriRicerca = () => window.dispatchEvent(new KeyboardEvent("keydown", { key: "k", ctrlKey: true }));
  const apriGuida = () => window.dispatchEvent(new CustomEvent("nexiora:guida"));
  const link = { background: "none", border: "none", padding: 0, color: "#6d28d9", fontWeight: 800, textDecoration: "underline", cursor: "pointer", fontFamily: "inherit", fontSize: "inherit" };

  // Testo viola in un riquadro chiaro con bordo viola (components/AvvisoViola.js): il fondo
  // viola pieno di prima era invasivo.
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 10, ...STILE_AVVISO_VIOLA, padding: "11px 14px", marginBottom: 16, fontSize: 13, lineHeight: 1.55 }}>
      <span style={{ fontSize: 16, lineHeight: 1.3 }}>🧭</span>
      <div style={{ flex: 1 }}>
        <strong>Benvenuto in Nexiora.</strong> Questa è la tua Home: ogni giorno qui trovi le cose da guardare, le attività e le commesse.
        {" "}Le sezioni sono nel menu {telefono ? "(☰ in alto)" : "a sinistra"} · per trovare qualsiasi cosa {telefono
          ? <>usa la <button onClick={apriRicerca} style={link}>ricerca 🔍</button></>
          : <>premi <button onClick={apriRicerca} style={link}>Ctrl + K</button></>}.
        {" "}<button onClick={apriGuida} style={link}>📖 Apri la guida →</button>
      </div>
      <button onClick={chiudi} title="Ho capito, non mostrare più" style={{ background: "none", border: "none", color: "#a78bfa", cursor: "pointer", padding: 2, display: "flex" }}><X size={16}/></button>
    </div>
  );
}
